export const state = {
  type: null,
  message: null,
  licenseNew: false,
  config: {
    time: {
      key: 10,
      label: "10 Detik"
    },
    alertCodes: []
  }
}

export const mutations = {
  success(state, message) {
    state.type = 'alert-success'
    state.message = message
  },
  error(state, message) {
    state.type = 'alert-danger'
    state.message = message
  },
  clear(state) {
    state.type = null
    state.message = null
  },
  configPopUp(state, payload) {
    state.config = payload
  }
}

export const actions = {
  success({ commit }, message) {
    commit('success', message)
  },
  error({ commit }, message) {
    commit('error', message)
  },
  clear({ commit }) {
    commit('clear')
  }
}
